module.exports = __webpack_public_path__ + "img/social_media.260cd814.svg";